import { History } from "history";
import ReactGA from "react-ga";

const initializeReactGA = (browserHistory: History): void => {
    const { gaTrackingId } = window.APP_SETTINGS;

    if (gaTrackingId) {
        ReactGA.initialize(gaTrackingId);

        browserHistory.listen(location => {
            ReactGA.set({ page: location.pathname });
            ReactGA.pageview(location.pathname);
        });
    }
};

export default initializeReactGA;
